import LabelLang from "component/LabelLang/label-lang";
import { YearTypeConst } from "constants/YearTypeConstant";
import Table from "react-bootstrap/Table";

function TableData({ columns, rows, indicatorName="", yearType = null }) {
  const GeneratingTableCells = () => {
    const rowsData = rows.map((item, i) => {
      return (
        <tr key={i}>
          {columns.flatMap((el, index) => {
            if (el.isIndicatorName) {
              return (
                <td key={index}>
                  <LabelLang
                    id={"name"}
                    defaultValue={item[0].name}
                    translations={item[0].translations}
                  />
                </td>
              );
            }
            const currentYear = el.headerName;
            const getRecordWithYear = item.filter(
              (att) =>
                att.month + " " + att.quarter + " " + att.year.toString() ===
                currentYear
            );

            if (
              getRecordWithYear.length > 0 &&
              getRecordWithYear[0].value !== null
            ) {
              return <td key={index}>{Math.round((getRecordWithYear[0].value + Number.EPSILON) * 10) / 10}</td>;
            }
            return <td key={index}>{"N/A"}</td>;
          })}
        </tr>
      );
    });
    return rowsData;
  };

  return (
    <Table
      responsive
      striped
      bordered
      hover
      className="text-center"
      id="table-to-xls"
    >
      <caption>{indicatorName}</caption>
      <thead>
        <tr>
          {columns.map(({ headerName }, i) => {
             const currentYearNoSpace = headerName.replaceAll(' ','');
             const yearHeaderName =
             yearType && yearType === YearTypeConst.Maly && i !== 0
                 ? `${(currentYearNoSpace - 1).toString()}/${currentYearNoSpace.toString()}`
                 : headerName.toString();
            return <th key={i}>{yearHeaderName}</th>;
          })}
        </tr>
      </thead>
      <tbody>
        <GeneratingTableCells />
      </tbody>
    </Table>
  );
}

export default TableData;
